// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import loadCurrentShipTos from "@insite/client-framework/Store/Data/ShipTos/Handlers/LoadCurrentShipTos";
import { getCurrentShipTosDataView } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

const useCurrentShipTosDataView = () => {
    const hasLoaded = useRef(false);
    const dispatch = useDispatch();
    const shipTos = useSelector((state: ApplicationState) => getCurrentShipTosDataView(state));
    if (!shipTos.isLoading && !shipTos.value && !hasLoaded.current) {
        dispatch(loadCurrentShipTos());
        hasLoaded.current = true;
    }
    return shipTos;
};

export default useCurrentShipTosDataView;
